<!-- bonus.wxml -->
<template>
    <div class="add-address-box">
        <div class="addr-item">
            <div class="item-name">收货人</div>
            <div class="item-input">
                <input v-model="addressInfo.name" style="width: 100%" type="text" placeholder="请输入收货人姓名"/>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">性别</div>
            <div class="item-input">
                <select class="select-sex" v-model="addressInfo.user_sex">
                    <option value="先生">先生</option>
                    <option value="女士">女士</option>
                </select>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">手机号(+1)</div>
            <div class="item-input">
                <input v-model="addressInfo.phone" type="number" style="width: 100%" placeholder="请输入收货人联系电话"/>
            </div>
        </div>

        <div class="addr-item">
            <div class="item-name">门牌和街道</div>
            <div class="item-input">
                <input v-model="addressInfo.street" type="text" style="width: 100%" placeholder="请补充门牌和街道"/>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">城市</div>
            <div class="item-input">
                <input v-model="addressInfo.city" type="text" style="width: 100%" placeholder="请输入城市信息"/>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">州</div>
            <div class="item-input">
                <input v-model="addressInfo.province" type="text" style="width: 100%" placeholder="请输入州信息"/>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">ZIP</div>
            <div class="item-input">
                <input v-model="addressInfo.proper_code" type="text" placeholder="请准确填写所在地邮编（配送以此为准）"/>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">邮箱</div>
            <div class="item-input">
                <input v-model="addressInfo.email" style="width: 100%" type="text" placeholder="请输入联系邮箱(非必填)"/>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">地址类型</div>
            <div class="item-input">
                <select class="select-sex" v-model="addressInfo.home_address">
                    <option value="0">请选择您的地址类型</option>
                    <option value="10">家庭住址</option>
                    <option value="20">商业住址</option>
                </select>
            </div>
        </div>
        <div class="addr-item">
            <div class="item-name">设为默认</div>
            <div class="item-input">
                <nut-switch
                    :active="true"
                    @change="defaultChange"
                >
                </nut-switch>
            </div>
        </div>
        <div class="submit-add" @click="summitAddr">立即提交</div>
    </div>
</template>
<script>
const fakeDataUrl = '/api/banner/index'
import Tabber from '@/components/Tabber.vue'

export default {
    name: 'MemberEditAddress',
    components: {
        Tabber
    },
    data() { //默认数据
        return {
            address_id: 0, // 收货地址 id
            addressInfo: {
                name: '',
                phone: '',
                city: '',
                province: '',
                street: '',
                proper_code: '',
                user_sex: '先生',
                code: '',
                home_address: '0',
            },
            disabled: true, // 是否可以提交
            isdefault: 1, // 是的默认选中地址
            codeDown: null,
            isCode: true,
            downNum: 60,
            isCheckCode: false, // 验证码是否正确
            codeCountDown: '获取验证码',
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.address_id = _this.$route.query.address_id;
        _this.getDetail();
    },
    methods: {

        // 数据回填
        getDetail() {
            let _this = this;
            _this._get('address/detail', {
                address_id: _this.address_id
            }, function (result) {
                _this.addressInfo = result.data.detail
                _this.addressInfo.street = result.data.detail.detail
                _this.loading.hide();
            });
        },


        /**
         * 添加地址提交
         */
        summitAddr: function (e) {
            let _this = this;
            if (!_this._verification(_this.addressInfo)) {
                return false;
            }
            _this.addressInfo.address_id = _this.address_id;
            _this.addressInfo.isdefault = _this.isdefault;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            // 提交到后端
            _this._post_form('address/edit_sanfang', _this.addressInfo, function (result) {
                _this.$toast.success(result.msg, {
                    onClose: function () {
                        _this.$router.go(-1);
                    }
                });
                // 解除按钮禁用
                _this.loading.hide()
            });
        },

        checkCode() {
            let _this = this;
            if (_this.addressInfo.code.length) {
                _this._get('sms/check', {
                    code: _this.addressInfo.code,
                }, res => {
                    _this.$toast.success(res.msg);
                    _this.isCheckCode = res.code == 200 ? true : false
                });
            }
        },

        //获取手机验证码
        getCode() {
            let _this = this;
            if (_this.addressInfo.phone == '' || _this.addressInfo.phone.length > 11) {
                _this.$toast.fail('手机号码不正确');
                return false;
            }
            if (_this.isCode) {
                _this._get('sms/index', {
                    phone: _this.addressInfo.phone
                }, res => {
                    _this.$toast.success(res.msg, {
                        onClose: function () {
                            _this.isCode = false;
                            _this.countdown();
                        }
                    });
                })
            }
        },

        //倒计时
        countdown() {
            let _this = this;
            _this.codeCountDown = _this.downNum + 's';
            setTimeout(function () {
                if (_this.downNum > 1) {
                    _this.downNum--;
                    _this.countdown();
                } else {
                    _this.codeCountDown = '获取验证码';
                    _this.downNum = 0;
                    _this.isCode = true;
                }
            }, 1000);
        },

        /**
         * 默认
         */
        defaultChange: function (e) {
            this.isdefault = e ? 1 : 0;
        },

        // 规则校验
        _verification(data) {
            let _this = this;
            if (data.phone == '' || data.phone.length >= 12) {
                _this.$toast.fail('手机号码不正确');
                return false;
            }
            if (data.name == '') {
                _this.$toast.fail('姓名不符合规则');
                return false;
            }
            if (data.street == '') {
                _this.$toast.fail('门牌和街道不能为空');
                return false;
            }
            if (data.city == '') {
                _this.$toast.fail('城市不能为空');
                return false;
            }
            if (data.province == '') {
                _this.$toast.fail('州不能为空');
                return false;
            }
            if (data.proper_code == '') {
                _this.$toast.fail('ZIP不能为空');
                return false;
            }
            if (data.home_address == 0) {
                _this.$toast.fail('请选择地址类型');
                return false;
            }

            return true;
        },
    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
    }
}
</script>
<style lang="scss">
@import "add_address.scss";
</style>
